import React from 'react';
import ReactDOM from 'react-dom/client';
import AdminApp from './components/AdminApp';
import './styles/admin-app.scss';

// Get the container for the Addons Manager tab.
const container = document.getElementById('woocommerce-addon-admin');
if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(<AdminApp productId={woocommerceAddonAdmin.product_id} />);
}
